import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../services/i18nService';

import OptionButton from './OptionButton';

const HideTimeRemainingButton = ({ clickHandler, a11yAttributes }) => {
    return (<OptionButton
        iconClass="fa fa-eye-slash fa-fw"
        clickHandler={clickHandler}
        title={t('options.hideTimeRemainingTitle')}
        a11yAttributes={a11yAttributes}
    />);
};

HideTimeRemainingButton.propTypes = {
    clickHandler: PropTypes.func.isRequired,
    a11yAttributes: PropTypes.object,
};

export default HideTimeRemainingButton;
